import { Fragment, h } from "preact";

import { renderHtml } from "../helpers.js";
import widgetApi from "../api/widget.js";
import { useEffect, useState } from "preact/hooks";

/**
 * This is shown when the user sees the result the first time.
 */
export default function LoadWidget({ hideDefault, taskId }) {
  const [html, setHtml] = useState(null);
  useEffect(async () => {
    const html = await widgetApi.task(taskId);

    if (!hideDefault || html.indexOf("Smart Tasklist") == -1) {
      setHtml(html);
    }
  }, []);

  return <div>{renderHtml(html)}</div>;
}
